import styled from "styled-components";

export const StyledCatalogueTopbarContainerDiv = styled.div`
  position: sticky;
  top: 0;
  z-index: 100;
  background: #fff;
  margin: 0;
  padding: 40px 136px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const StyledCatalogueTopbarLeftDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 36px;

  .headerH2 {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const StyledIconContainerDiv = styled.div`
  width: 39px;
  height: 37px;
  border-radius: 4px;
  background: #1249bf;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledSearchContainerDiv = styled.div`
  display: flex;
  width: 526px;
  height: 40px;
  padding: 8px 16px 8px 12px;
  align-items: center;
  gap: 8px;

  border-radius: 4px;
  border: 1px solid var(--Light---ui-border-color, #c5c7d0);
  background: var(--MIST, #f7f8f9);

  input {
    width: 100%;
    border: none;
    background-color: transparent;
    outline: none;
  }

  svg {
    cursor: pointer;
  }
`;

export const StyledCatalogueTopbarRightDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const StyledCatalogueTopbarCartContainerDiv = styled.div`
  border-radius: 4px;
  background: #1249bf;
  display: inline-flex;
  height: 34px;
  padding: 4px 15px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  color: var(--CLOUD, #fcfdfe);
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
  text-decoration: none;

  &:hover {
    background: #0f3da3;
  }
`;

export const StyledCircleIconDiv = styled.div`
  width: 20px;
  height: 20px;
  background-color: #cf324a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  color: #fff;
`;
